// TODOXDOCK check deletion of this variable
const SERVICE_TYPE_ONTRUCK24 = 'ONTRUCK24';

export { SERVICE_TYPE_ONTRUCK24 };
